import React, { useState, useEffect, useRef } from "react";
import { Phone, PhoneOff, Delete, Mic, MicOff, Pause, Play, Keyboard, X } from "lucide-react";
// import { getRecordingUrl } from "../S3Service";
import RequestSentDetailsDS from "../../DataServices/RequestSentDetailsDS";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import NotesModal from "./NotesModal";
import { insertLog } from "../Logs/InsertLog";
import "./DialModal.css";

// ─── Amazon Connect Config ────────────────────────────────────────────────────
// const CONNECT_INSTANCE_URL = "https://ws0122-stage.my.connect.aws";
// const QUEUE_ARN ="arn:aws:connect:us-east-1:896271372054:instance/f294f921-351b-46a1-8f74-e4fa739f92c8/queue/f53db849-ebaf-4971-9cf7-d70f979bef25";

// ─── Static data ──────────────────────────────────────────────────────────────
const KEY_LABELS = {
  1: "", 2: "ABC", 3: "DEF",
  4: "GHI", 5: "JKL", 6: "MNO",
  7: "PQRS", 8: "TUV", 9: "WXYZ",
  "*": "", 0: "+", "#": "",
};
const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"];

const fmtTime = (s) =>
  `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

// ─── Component ────────────────────────────────────────────────────────────────
export default function DialModal({ isOpen, onClose, requestID, agencyPhoneNumber, agencyName, fetchHistory, refresh }) {
  // ── State ──────────────────────────────────────────────────────────────────
  const [number, setNumber] = useState("");
  const [callState, setCallState] = useState("idle");
  const [muted, setMuted] = useState(false);
  const [held, setHeld] = useState(false);
  const [elapsed, setElapsed] = useState(0);
  const [agentReady, setAgentReady] = useState(false);
  const [statusMsg, setStatusMsg] = useState("Initializing Connect…");
  const [errorMsg, setErrorMsg] = useState("");
  const [showManual, setShowManual] = useState(false);
  const [agentStates, setAgentStates] = useState([]);
  const [dialedNumber, setDialedNumber] = useState("");
  const [dtmfLog, setDtmfLog] = useState("");
  const [currentAgentState, setCurrentAgentState] = useState("");
  const [callHistory, setCallHistory] = useState([]);
  const [finalDuration, setFinalDuration] = useState(0);
  const [contactId, setContactId] = useState("");
  const [showNotes, setShowNotes] = useState(false);
  const [phoneNumber, setphoneNumber] = useState(agencyPhoneNumber)

  // Recording playback
  const [playingId, setPlayingId] = useState(null);
  const [loadingId, setLoadingId] = useState(null);
  const audioRef = useRef(null);
  const useremail = localStorage.getItem("email");
  const userName = useremail?.split("@")[0];

  // ── Refs ───────────────────────────────────────────────────────────────────
  const hiddenCcpRef = useRef(null);
  const agentRef = useRef(null);
  const contactRef = useRef(null);
  const timerRef = useRef(null);
  const ccpInitialized = useRef(false);
  const manualInputRef = useRef(null);
  const callStartRef = useRef(null);
  const callStateRef = useRef("idle");
  const isDestroyingRef = useRef(false);

  const { showAlert, hud, stopHudRotation, showToast } = useCustomContext();



  // ── Helpers ────────────────────────────────────────────────────────────────
  const updateCallState = (state) => {
    callStateRef.current = state;
    setCallState(state);
  };
  useEffect(() => {
    if (agencyPhoneNumber) {
      setphoneNumber(agencyPhoneNumber);
    } else {
      const stored = localStorage.getItem("CurrentAgencyNumber");
      if (stored && stored !== "undefined") {
        setphoneNumber(stored);
      }
    }
  }, [agencyPhoneNumber]);



  useEffect(() => {
    if (isOpen && phoneNumber) {
      setNumber(phoneNumber);
      setShowManual(false); // hide manual input
    }
    console.log("dialPhoneNumber", phoneNumber);
  }, [isOpen, phoneNumber]);

  useEffect(() => {
    if (!isOpen) return;
    if (!phoneNumber) return;
    if (!agentReady) return;
    if (callState !== "idle") return;

    initiateCall();
  }, [isOpen, phoneNumber, agentReady]);


  // ── Call history ───────────────────────────────────────────────────────────
  const fetchCallHistory = async (showLoader = false) => {
    // if (showLoader) hud("Please wait");
    // try {
    //   const payload = localStorage.getItem("rememberedEmail")
    //     ? { agent_email: localStorage.getItem("rememberedEmail") }
    //     : {};
    //   const ds   = new HomeDS();
    //   const resp = await ds.AC_Call_Info_History(payload);
    //   if (resp?.data?.statusCode === 200) {
    //     setCallHistory(resp?.data?.body || []);
    //     return resp?.data?.body || null;
    //   } else {
    //     showToast({ message: resp?.data?.body?.error || "Something went wrong" });
    //     return null;
    //   }
    // } catch (err) {
    //   showToast({ message: err?.message || "Network error" });
    //   return null;
    // } finally {
    //   if (showLoader) stopHudRotation();
    // }
  };

  useEffect(() => { fetchCallHistory(true); }, []);

  // ── Recording playback ─────────────────────────────────────────────────────
  // const playRecording = async (item) => {
  //   if (audioRef.current) { audioRef.current.pause(); audioRef.current = null; }
  //   if (playingId === item._id) { setPlayingId(null); return; }
  //   setLoadingId(item._id);
  //   try {
  //     const url   = await getRecordingUrl(item.call_s3_key);
  //     const audio = new Audio(url);
  //     audioRef.current  = audio;
  //     audio.onended     = () => setPlayingId(null);
  //     audio.onerror     = () => { setPlayingId(null); showToast({ message: "Failed to load recording" }); };
  //     await audio.play();
  //     setPlayingId(item._id);
  //   } catch (err) {
  //     showToast({ message: "Could not load recording: " + err.message });
  //   } finally {
  //     setLoadingId(null);
  //   }
  // };

  // ── Connect CCP init ───────────────────────────────────────────────────────
  useEffect(() => {
    if (ccpInitialized.current || !isOpen) return;
    ccpInitialized.current = true;

    if (!window.connect) { setStatusMsg("Connect SDK not loaded."); return; }

    // Auto-close contact helper (sets Busy, then opens notes)
    const autoCloseContact = () => {
      const agent = agentRef.current;
      const setStateByName = (name, cb) => {
        const target = agent?.getAgentStates()?.find((s) => s.name === name);
        if (target) {
          agent.setState(target, {
            success: cb,
            failure: (err) => console.error(`Failed to set ${name}`, err),
          });
        } else { cb?.(); }
      };
      setStateByName("Offline", () => {
        updateCallState("idle");
        setElapsed(0);
        setStatusMsg("Offline");
        setShowNotes(true);           // ← open notes modal
        // onClose();
      });
    };

    // window.connect.core.initCCP(hiddenCcpRef.current, {
    //   ccpUrl: `${process.env.REACT_APP_CONNECT_INSTANCE_URL}/ccp-v2/`,
    //   loginPopup: true,
    //   loginPopupAutoClose: true,
    //   loginOptions: { autoClose: true, height: 600, width: 400 },
    //   softphone: { allowFramedSoftphone: true },
    // });

    if (!window.__CONNECT_INITIALIZED__) {
      window.__CONNECT_INITIALIZED__ = true;

      window.connect.core.initCCP(hiddenCcpRef.current, {
        ccpUrl: `${process.env.REACT_APP_CONNECT_INSTANCE_URL}/ccp-v2/`,
        loginPopup: true,
        loginPopupAutoClose: true,
        loginOptions: { autoClose: true, height: 600, width: 400 },
        softphone: { allowFramedSoftphone: true },
      });
    }

    window.connect.agent((agent) => {
      agentRef.current = agent;
      setAgentReady(true);
      const current = agent.getState()?.name;
      setCurrentAgentState(current);
      setAgentStates(agent.getAgentStates());
      setStatusMsg(`Agent · ${current}`);
      agent.onStateChange((evt) => {
        setCurrentAgentState(evt.newState);
        setStatusMsg(`Agent · ${evt.newState}`);
      });
    });

    window.connect.contact((contact) => {
      contactRef.current = contact;

      contact.onConnecting(() => {
        updateCallState("connecting");
        setStatusMsg("Connecting…");
        if (!callStartRef.current) callStartRef.current = Date.now();
      });

      contact.onAccepted(() => {
        callStartRef.current = Date.now();
        updateCallState("connected");
        setStatusMsg("Call live");
        timerRef.current = setInterval(() => {
          setElapsed(Math.floor((Date.now() - callStartRef.current) / 1000));
        }, 1000);
      });

      contact.onEnded(() => {
        clearInterval(timerRef.current);
        const duration = callStartRef.current
          ? Math.floor((Date.now() - callStartRef.current) / 1000)
          : 0;
        setContactId(contact.getContactId());
        setFinalDuration(duration);
        callStartRef.current = null;
        setMuted(false);
        setHeld(false);
        setDtmfLog("");
        setStatusMsg("After call work…");
        contactRef.current = null;
        isDestroyingRef.current = false;
        setErrorMsg("");
        setDialedNumber("");
        setTimeout(() => autoCloseContact(), 500);
      });

      contact.onError((err) => {
        clearInterval(timerRef.current);
        setErrorMsg(err?.message || "Call error");
        updateCallState("idle");
      });
    });

    return () => {
      clearInterval(timerRef.current);
      ccpInitialized.current = false;
    };
  }, [isOpen]);

  // ── Notes submit (save + set Available) ───────────────────────────────────
  const handleNotesSubmit = async (notesText, status) => {
    hud("Please Wait");
    try {
      const payload = {
        agent_email: localStorage.getItem("email") || "",
        called_to: dialedNumber || number || "",
        called_from: "+1 877-424-6963",
        call_status: status.value,
        notes: notesText,
        call_duration: finalDuration || 0,
        vin_id: requestID,
        caller_id: contactId,
        isIncoming: false
      };

      console.log("payload:", payload)
      const ds = new RequestSentDetailsDS();
      const resp = await ds.AC_Call_Info_ADD(payload);
      if (resp?.data?.statusCode === 200) {
        insertLog(
          `${userName} completed Call for Action for VIN '${requestID}' and agency '${agencyName}'`,
          0,
          useremail,
          hud,
          stopHudRotation,
          showAlert,
          requestID || '',
          'INSERT',
          'AC_Call_Info_ADD',
          'SUCCESS',
          ''
        );
        showToast({ message: resp?.data?.body?.message || "Saved successfully" });
        setShowNotes(false);
        setDialedNumber("");
        setNumber("");
        setFinalDuration(0);
        setContactId("");
        fetchHistory(requestID)
        onClose();
        refresh();

        // Set agent back to Available
        const agent = agentRef.current;
        if (agent) {
          const states = agent.getAgentStates();
          const Offline = states.find((s) => s.name === "Offline");
          if (Offline) {
            agent.setState(Offline, {
              success: () => setStatusMsg("Ready"),
              failure: (err) => console.error("Failed to set Available", err),
            });
          }
        }
        // await fetchCallHistory(false);
      } else {

        insertLog(
          `${userName} failed Call for Action for VIN '${requestID}' and agency '${agencyName}'`,
          0,
          useremail,
          hud,
          stopHudRotation,
          showAlert,
          requestID || '',
          'INSERT',
          'AC_Call_Info_ADD',
          'FAILED',
          'Call for Action could not be completed'
        );

        showToast({ message: resp?.data?.body?.error || "Something went wrong" });
      }
    } catch (err) {
      insertLog(
        `${userName} failed Call for Action for VIN '${requestID}' and agency '${agencyName}'`,
        0,
        useremail,
        hud,
        stopHudRotation,
        showAlert,
        requestID || '',
        'INSERT',
        'AC_Call_Info_ADD',
        'FAILED',
        'Unexpected error while processing Call for Action'
      );
      showToast({ message: err?.message || "Network error" });
    } finally {
      stopHudRotation();
    }
  };

  // ── Agent state change ─────────────────────────────────────────────────────
  const changeAgentState = (stateName) => {
    const agent = agentRef.current;
    const target = agent?.getAgentStates()?.find((s) => s.name === stateName);
    if (!target) return;
    agent.setState(target, {
      success: () => console.log("Changed to", stateName),
      failure: (err) => console.error("State change failed", err),
    });
  };

  // ── Dial pad key press ─────────────────────────────────────────────────────
  const pressKey = (key) => {
    if (callState === "connected" || callState === "connecting") {
      if (contactRef.current?.sendDigits) {
        contactRef.current.sendDigits(key);
      } else {
        const conn = contactRef.current?.getAgentConnection();
        if (conn?.sendDigits) conn.sendDigits(key);
        else if (conn?.sendDigit) conn.sendDigit(key);
      }
      setDtmfLog((prev) => (prev.length < 20 ? prev + key : prev.slice(1) + key));
      return;
    }
    setNumber((prev) => (prev.length < 15 ? prev + key : prev));
  };

  const deleteLast = () => setNumber((prev) => prev.slice(0, -1));
  const clearNumber = () => setNumber("");

  // ── Initiate call ──────────────────────────────────────────────────────────
  const initiateCall = () => {
    if (!number || !agentRef.current) return;

    setErrorMsg("");
    const formatted = number.startsWith("+") ? number : "+1" + number;
    setDialedNumber(formatted);

    const agent = agentRef.current;
    const states = agent.getAgentStates();
    const currentState = agent.getState().name;

    // ✅ If already Available, directly call
    if (currentState === "Available") {
      updateCallState("connecting");
      setStatusMsg("Connecting…");
      const endpoint = window.connect.Endpoint.byPhoneNumber(formatted);
      agent.connect(endpoint, { queueARN:process.env.REACT_APP_QUEUE_ARN });
      return;
    }

    // ✅ Not Available → set to Available first, then call
    const available = states.find((s) => s.name === "Available");
    if (!available) {
      setErrorMsg("Available state not found.");
      return;
    }

    setStatusMsg("Setting agent to Available…");

    agent.setState(available, {
      success: () => {
        // ✅ Now initiate call after becoming Available
        updateCallState("connecting");
        setStatusMsg("Connecting…");
        const endpoint = window.connect.Endpoint.byPhoneNumber(formatted);
        agentRef.current.connect(endpoint, { queueARN:process.env.REACT_APP_QUEUE_ARN  });
      },
      failure: (err) => {
        console.error("Failed to set Available", err);
        setErrorMsg("Failed to set agent to Available.");
      },
    });
  };

  // ── Hang up ────────────────────────────────────────────────────────────────
  const hangUp = () => {
    if (isDestroyingRef.current) return;
    const contact = contactRef.current;
    if (!contact) return;
    try {
      isDestroyingRef.current = true;
      const agentConnection = contact.getAgentConnection();
      if (agentConnection) {
        agentConnection.destroy({
          success: () => { isDestroyingRef.current = false; },
          failure: (err) => { console.error("Destroy failed", err); isDestroyingRef.current = false; },
        });
      } else {
        contact.destroy({
          success: () => { isDestroyingRef.current = false; },
          failure: (err) => { console.error("Destroy failed", err); isDestroyingRef.current = false; },
        });
      }
    } catch (err) {
      console.error("Hard crash in hangUp:", err);
      isDestroyingRef.current = false;
    }
  };

  // ── Mute / Hold ────────────────────────────────────────────────────────────
  const toggleMute = () => {
    if (!agentRef.current) return;
    muted ? agentRef.current.unmute() : agentRef.current.mute();
    setMuted((m) => !m);
  };

  const toggleHold = () => {
    const conn = contactRef.current?.getAgentConnection();
    if (!conn) return;
    held
      ? conn.resume({ success: () => setHeld(false) })
      : conn.hold({ success: () => setHeld(true) });
  };

  // ── Derived flags ──────────────────────────────────────────────────────────
  const isIdle = callState === "idle";
  const isConnecting = callState === "connecting";
  const isConnected = callState === "connected";
  const isAfterCall = callState === "aftercall";

  // ── Guard: don't render if modal closed ───────────────────────────────────
  if (!isOpen) return (
    <div ref={hiddenCcpRef} style={{ display: "none" }} />
  );
  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
      {/* Hidden CCP iframe (always in DOM once modal mounts) */}
      <div ref={hiddenCcpRef} style={{ display: "none" }} />

      {/* ── Overlay ── */}
      <div className="dial-overlay" onClick={(e) => {
        if (e.target === e.currentTarget && isIdle && onClose) {
          onClose();
        }
      }}>
        <div className="dial-modal">

          {/* ══ LEFT: Dial pad card ══════════════════════════════════════════ */}
          <div className="dial-card">

            {/* Close button (only when idle) */}
            {isIdle && onClose && (
              <button
                className="dial-close-btn"
                onClick={onClose}
                title="Close"
              >
                <X size={14} />
              </button>
            )}

            {/* Status bar */}
            <div className="dial-status-bar">
              <span
                className={`dial-status-dot${!agentReady ? "" :
                  isConnected ? " dial-status-dot--calling" :
                    isAfterCall ? " dial-status-dot--aftercall" :
                      " dial-status-dot--ready"
                  }`}
              />
              {statusMsg}
            </div>

            {/* Agent state pills */}
            {/* <div className="dial-agent-states">
              {agentStates.map((s) => (
                <button
                  key={s.name}
                  className={`dial-agent-state-btn${s.name === currentAgentState ? " dial-agent-state-btn--active" : ""
                    }`}
                  onClick={() => changeAgentState(s.name)}
                >
                  {s.name}
                </button>
              ))}
            </div> */}

            {/* Number display */}
            <div className="dial-display-area">
              <div className="dial-display-label">
                {isConnected ? "CONNECTED TO" :
                  isConnecting ? "CALLING" :
                    isAfterCall ? "LAST CALL" :
                      "NUMBER"}
              </div>

              {(isConnected || isConnecting) ? (
                <div className="dial-display-number">{dialedNumber || number}</div>
              ) : isAfterCall ? (
                <div className="dial-display-number dial-display-number--dim">
                  {dialedNumber || number}
                </div>
              ) : (
                <div className={`dial-display-number${!number ? " dial-display-number--empty" : ""}`}>
                  {number ? (
                    <>
                      {number}
                      {!phoneNumber && <span className="dial-cursor" />}
                    </>
                  ) : "Enter number"}
                </div>
              )}

              {isConnected && (
                <div className={`dial-call-timer${held ? " dial-call-timer--held" : ""}`}>
                  {fmtTime(elapsed)}{held ? " · HOLD" : ""}
                </div>
              )}
              {isAfterCall && (
                <div className="dial-call-timer dial-call-timer--done">
                  {fmtTime(finalDuration)}
                </div>
              )}
            </div>

            {/* Mode toggle (idle only) */}
            {isIdle && !phoneNumber && (
              <div className="dial-toggle-row">
                <button
                  className={`dial-toggle-btn${!showManual ? " dial-toggle-btn--active" : ""}`}
                  onClick={() => setShowManual(false)}
                >
                  <Keyboard size={12} /> Dial Pad
                </button>
                <button
                  className={`dial-toggle-btn${showManual ? " dial-toggle-btn--active" : ""}`}
                  onClick={() => {
                    setShowManual(true);
                    setTimeout(() => manualInputRef.current?.focus(), 50);
                  }}
                >
                  ✎ Type Manually
                </button>
              </div>
            )}

            {/* Manual input */}
            {showManual && isIdle && !phoneNumber && (
              <div className="dial-manual-input-wrap">
                <input
                  ref={manualInputRef}
                  className="dial-manual-input"
                  type="tel"
                  placeholder="+1 (555) 000-0000"
                  value={number}
                  onChange={(e) =>
                    setNumber(e.target.value.replace(/[^0-9+*#]/g, "").slice(0, 15))
                  }
                />
              </div>
            )}

            {/* Error */}
            {errorMsg && <div className="dial-error-msg">⚠ {errorMsg}</div>}

            {/* IVR panel */}
            {(isConnected || isConnecting) && (
              <div className="dial-ivr-panel">
                <div className="dial-ivr-panel-label">
                  <span className="dial-ivr-dot" />
                  IVR / EXTENSION NAVIGATION
                </div>
                <div className="dial-ivr-keys-display">
                  {dtmfLog ? (
                    <><span className="dial-ivr-keys-typed">{dtmfLog}</span><span className="dial-cursor" /></>
                  ) : (
                    <span className="dial-ivr-keys-hint">Press keys below to navigate…</span>
                  )}
                </div>
              </div>
            )}

            {/* Dial grid */}
            {(!showManual || isConnected || isConnecting) && !isAfterCall && (!phoneNumber || isConnected || isConnecting) && (
              <div className="dial-grid">
                {KEYS.map((key) => (
                  <button
                    key={key}
                    className={`dial-key${isConnected || isConnecting ? " dial-key--ivr" : ""}`}
                    onClick={() => pressKey(key)}
                  >
                    <span className="dial-key-main">{key}</span>
                    {KEY_LABELS[key] && <span className="dial-key-sub">{KEY_LABELS[key]}</span>}
                  </button>
                ))}
              </div>
            )}

            {/* Action bar */}
            {!isAfterCall && (
              <div className="dial-action-bar">
                {isIdle && !showManual && !phoneNumber && (
                  <button className="dial-btn-circle dial-btn-sm dial-btn-ghost" onClick={deleteLast} title="Delete">
                    <Delete size={16} />
                  </button>
                )}

                {isConnected && (
                  <button
                    className={`dial-btn-circle dial-btn-sm ${muted ? "dial-btn-warn" : "dial-btn-ghost"}`}
                    onClick={toggleMute}
                    title={muted ? "Unmute" : "Mute"}
                  >
                    {muted ? <MicOff size={16} /> : <Mic size={16} />}
                  </button>
                )}

                {isIdle && !phoneNumber && (
                  <button
                    className="dial-btn-circle dial-btn-lg dial-btn-call"
                    onClick={initiateCall}
                    disabled={!number || !agentReady}
                    title="Call"
                  >
                    <Phone size={22} />
                  </button>
                )}

                {isConnecting && (
                  <button className="dial-btn-circle dial-btn-lg dial-btn-end" onClick={hangUp} title="Cancel Call">
                    <PhoneOff size={22} />
                  </button>
                )}

                {isConnected && (
                  <button className="dial-btn-circle dial-btn-lg dial-btn-end" onClick={hangUp} title="End call">
                    <PhoneOff size={22} />
                  </button>
                )}

                {isConnected && (
                  <button
                    className={`dial-btn-circle dial-btn-sm ${held ? "dial-btn-warn" : "dial-btn-ghost"}`}
                    onClick={toggleHold}
                    title={held ? "Resume" : "Hold"}
                  >
                    {held ? <Play size={16} /> : <Pause size={16} />}
                  </button>
                )}

                {isIdle && number && !phoneNumber && (
                  <button className="dial-btn-circle dial-btn-sm dial-btn-danger-ghost" onClick={clearNumber} title="Clear">
                    ✕
                  </button>
                )}
              </div>
            )}

            {/* State label */}
            <div className="dial-state-label">
              {isIdle && "Calling ..."}
              {isConnecting && "placing call…"}
              {isConnected && (held ? "call on hold" : "call in progress")}
              {isAfterCall && "complete wrap-up, then close"}
            </div>
          </div>



        </div>
      </div>

      {/* ── Post-call notes modal ── */}
      <NotesModal
        isOpen={showNotes}
        dialedNumber={dialedNumber || number}
        finalDuration={finalDuration}
        onSubmit={handleNotesSubmit}
      />
    </>
  );
}